"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ELang = exports.CurrencyEnum = exports.EPlatform = exports.TaskValidityPeriodUnitEnum = exports.EValid = exports.BUSINESS_LOCATIONS = exports.BusinessLocation = void 0;
const constant_sage_1 = require("constant-sage");
/**
 * 业务地区枚举
 * 所有地区代码统一使用大写
 */
var BusinessLocation;
(function (BusinessLocation) {
    /** 新加坡 */
    BusinessLocation["SG"] = "SG";
    /** 马来西亚 */
    BusinessLocation["MY"] = "MY";
    /** 日本 */
    BusinessLocation["JP"] = "JP";
    /** 香港 */
    BusinessLocation["HK"] = "HK";
    /** 澳大利亚 */
    BusinessLocation["AU"] = "AU";
    /** 美国 */
    BusinessLocation["US"] = "US";
    /** 加拿大 */
    BusinessLocation["CA"] = "CA";
    /** 新西兰 */
    BusinessLocation["NZ"] = "NZ";
})(BusinessLocation || (exports.BusinessLocation = BusinessLocation = {}));
/**
 * 所有支持的业务地区列表
 */
exports.BUSINESS_LOCATIONS = Object.values(BusinessLocation);
/**
 * 数据有效性: 1:有效 0:无效，默认为1
 */
var EValid;
(function (EValid) {
    /**
     * 有效
     */
    EValid[EValid["Valid"] = 1] = "Valid";
    /**
     * 无效
     */
    EValid[EValid["Invalid"] = 0] = "Invalid";
})(EValid || (exports.EValid = EValid = {}));
const periodItems = [
    {
        key: 'day',
        value: 0,
    },
    {
        key: 'week',
        value: 1,
    },
    {
        key: 'month',
        value: 2,
    },
    {
        key: 'year',
        value: 3,
    },
];
exports.TaskValidityPeriodUnitEnum = (0, constant_sage_1.defineConstants)(periodItems);
var EPlatform;
(function (EPlatform) {
    EPlatform["FUTU"] = "futunn";
    EPlatform["MOOMOO"] = "moomoo";
})(EPlatform || (exports.EPlatform = EPlatform = {}));
const langItems = [
    {
        key: 'CN',
        value: 0,
    },
    {
        key: 'EN',
        value: 2,
    },
];
const currencyItems = [
    {
        key: 'USD',
        value: 'USD',
        name: '美元',
    },
    {
        key: 'SGD',
        value: 'SGD',
        name: '新加坡元',
    },
    {
        key: 'HKD',
        value: 'HKD',
        name: '港币',
    },
    {
        key: 'JPY',
        value: 'JPY',
        name: '日元',
    },
    {
        key: 'AUD',
        value: 'AUD',
        name: '澳元',
    },
    {
        key: 'NZD',
        value: 'NZD',
        name: '新西兰元',
    },
    {
        key: 'MYR',
        value: 'MYR',
        name: '马币',
    },
    {
        key: 'CAD',
        value: 'CAD',
        name: '加元',
    },
];
exports.CurrencyEnum = (0, constant_sage_1.defineConstants)(currencyItems);
exports.ELang = (0, constant_sage_1.defineConstants)(langItems);
